






















import { Vue,Component } from 'vue-property-decorator'
import { State,Action,namespace,Getter } from 'vuex-class'
const user = namespace('user')
@Component
export default class Home extends Vue{
    search:any = {
        name: '',
        mobile: '',
        page: 1
    }
    @user.State('userPager') userPager:any //表格的页码
    @user.State('userList') userList:any //用户列表
    @user.State('loading') loading:any 
    @Getter('clientRole') clientRole:any // 角色
    get tablecolumn(){
        return [
            {
                prop: 'name',
                type: 'text',
                label: '姓名',
            },
            {
                prop: 'mobile',
                type: 'text',
                label: '电话',
            },
            {
                prop: 'ctime',
                type: 'text',
                label: '创建时间',
            },
            {
                prop: 'role',
                name: 'role',
                type: 'slot',
                label: '角色',
            },
            {
                prop: 'site',
                nextProp: 'name',
                type: 'nextProp',
                label: '网点',
            },
            {
                prop: 'remarks',
                type: 'text',
                label: '备注',
            },
        ]
    }
    @user.Action('getCustomerList') getCustomerList:any
    created(){
        this.getList()
    }
    getList(){
        this.getCustomerList(this.search)
    }
    // 角色代码转换
    switchRole (key:string){
        let val = ''
        this.clientRole.forEach((item:any) => {
            if(item.code == key){
                val = item.name
            }
        });
        return val
    }
    // 网点代码转换
    switchSite (key:string){
        let val = ''
        this.clientRole.forEach((item:any) => {
            if(item.code == key){
                val = item.name
            }
        });
        return val
    }
    // 改变页码
    pagechange(e:any){
        this.search.page = e[0].val;
        this.getList()
    }
    
}
